import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import { apiString as API_URL } from '../utils/constants';
import { dateFormatter } from '../utils/timeFormat';
import { setIsLoading } from './shared.slice';
import { AppThunk } from './store';

const today = new Date();
const defaultStartDate = new Date(today);
defaultStartDate.setMonth(defaultStartDate.getMonth() - 1);

const heidiSessionExceptionsReport = createSlice({
    name: 'heidiSessionExceptionsReport',
    initialState: {
        startDate: defaultStartDate,
        endDate: today,
        rowData: [],
    },
    reducers: {
        _setStartDate(state, action) {
            state.startDate = action.payload;
        },
        _setEndDate(state, action) {
            state.endDate = action.payload;
        },
        _setRowData(state, action) {
            state.rowData = action.payload;
        },
    },
});

const { _setStartDate, _setEndDate, _setRowData } = heidiSessionExceptionsReport.actions;

export const setStartDate =
    (params: Date): AppThunk =>
    async (dispatch) => {
        dispatch(_setStartDate(params));
    };

export const setEndDate =
    (params: Date): AppThunk =>
    async (dispatch) => {
        dispatch(_setEndDate(params));
    };

export const setRowData =
    (params: []): AppThunk =>
    async (dispatch) => {
        dispatch(_setRowData(params));
    };

export const fetchHeidiSessionExceptionsReport =
    (startDate: Date, endDate: Date): AppThunk =>
    async (dispatch) => {
        dispatch(setIsLoading(true));
        const response = await axios.get(
            `${API_URL}/HeidiSessionExceptionReport/getheidisessionexceptions?startDate=${dateFormatter(startDate)}&endDate=${dateFormatter(endDate)}`
        );
        dispatch(setRowData(response.data));
        dispatch(setIsLoading(false));
    };

export default heidiSessionExceptionsReport.reducer;
